const formatResponse = (data) => ({
  iRet: 0,
  sMsg: "ok",
  data,
});

export default {
  "POST /v1/sys/update": formatResponse({
    appversion: "1.1.0",
    downLoadUrl: "www.baidu.com",
  }),
  "POST /v1/networkspeed/query": formatResponse({
    percent: 29.7,
    downloadSpeedCurve: [
      40.1,
      42.6,
      40.4,
      36.8,
      33,
      38.8,
      40.6,
      43.4,
      45.3,
      42.9,
      40.8,
      41.3,
      43.4,
      47.7,
      41.1,
      40.5,
      41.1,
      43.2,
      40.8,
      35.4,
      35.6,
      39.9,
      40,
      40.4,
      40.1,
      40.3,
      40.4,
      41.2,
      45.2,
      44.6,
      41.1,
      40.6,
      39.7,
      39.8,
      39.7,
      39.2,
      39.8,
      40.3,
      40.1,
      39.7,
      39.5,
      40.5,
      40.9,
      41.2,
      41.1,
      39.7,
      39.6,
      40,
      40.5,
      40,
      39.6,
      39.2,
      39.3,
      39.9,
      41,
      40.6,
      40,
      39.4,
      40.8,
      41.6,
      40.5,
      39.1,
      39.3,
      40.9,
      40.7,
      40.5,
      40.9,
      40.4,
      40.2,
      41,
      41,
      36.3,
      33.1,
      36.4,
      38.3,
      39.1,
      39.6,
      39.1,
      40,
      40.3,
      44.8,
      46.6,
      43.3,
      41.5,
      40.2,
      40.1,
      41.2,
      39.8,
      41,
      38.4,
    ],
    download: 41267.2,
    ip: "183.2.223.26",
    isp: "中国电信",
    location: "中国 广东省",
    netType: "wifi",
    delay: 48,
    stime: "2020-12-03 17:47:37",
    ts: 1606988857,
    uploadSpeedCurve: [
      6.5,
      8.1,
      8.1,
      9.7,
      10.8,
      11.3,
      11.3,
      12.9,
      14,
      15.1,
      16.1,
      16.7,
      17.7,
      18.3,
      18.8,
      18.8,
      20.4,
      20.4,
      22,
      22,
      24.2,
      25.3,
      25.3,
      26.9,
      28,
      28.5,
      29.6,
      29.3,
      29.9,
      30.3,
      30.1,
      30.7,
      30.1,
      30.1,
      30.7,
      30.1,
      30.7,
      29.6,
      30.7,
      30.1,
      30.7,
      30.7,
      30.7,
      29.6,
      30.7,
      30.7,
      31.2,
      31.2,
      30.7,
      31.2,
      31.2,
      31.2,
      31.2,
      30.1,
      31.2,
      31.2,
      31.2,
      31.7,
      30.1,
      31.2,
      31.2,
      30.7,
      31.2,
      31.2,
      31.2,
      30.7,
      30.7,
      31.7,
      31.2,
      31.2,
      32.3,
      31.2,
      31.2,
      31.2,
      31.2,
      31.2,
      31.2,
      31.2,
      30.7,
      30.7,
      31.7,
      31.2,
      31.7,
      31.7,
      30.1,
      30.1,
      31.7,
      31.2,
      31.7,
      30.7,
    ],
    upload: 34816,
  }),
};
